export const LANDING_PROD_URL = 'https://schooly.org';
export const PRIVACY_POLICY_URL = `${LANDING_PROD_URL}/privacy-policy/`;
export const YOUTUBE_URL = 'https://www.youtube.com/@schooly-app';
